/* Keep navigation progress beside its controls, leaving the look identity quiet. */
(() => {
  const enhance = dialog => {
    // The film belongs to the identity on every device, never to a product cell.
    // Reconcile after the existing responsive controller moves its film node.
    const identity=dialog.querySelector('.srlm-featured-focus__identity');
    const film=dialog.querySelector('.srlm-featured-focus__film');
    if(identity && film && film.parentElement!==identity){
      identity.prepend(film);
      film.setAttribute('aria-hidden','true');
      if(dialog.open && !document.hidden && !matchMedia('(prefers-reduced-motion: reduce)').matches)film.querySelector('video')?.play().catch(()=>{});
    }
    if (dialog.dataset.focusPolished) return;
    const footer = dialog.querySelector('.srlm-featured__top');
    const grid = dialog.querySelector('.srlm-featured__grid');
    if (!footer || !grid) return;
    dialog.dataset.focusPolished = 'true';
    const progress = document.createElement('span');
    progress.className = 'srlm-focus-progress';
    progress.setAttribute('role','status');
    progress.setAttribute('aria-live','polite');
    footer.insertBefore(progress,footer.querySelector('.srlm-featured-focus__nav'));
    const update = () => {
      if (!dialog.open) return;
      const cards = [...grid.querySelectorAll('.srlm-featured__item')];
      const rail = grid.getBoundingClientRect();
      const visible = cards.flatMap((card,index) => {
        const r=card.getBoundingClientRect();
        return Math.min(r.right,rail.right)-Math.max(r.left,rail.left)>r.width*.5 ? [index+1] : [];
      });
      const first=visible[0]||1,last=visible[visible.length-1]||first;
      const n = x => String(x).padStart(2,'0');
      cards.forEach(card => {
        const info=card.querySelector('.srlm-featured__item-info');
        if(info && info.dataset.pieceTotal!==n(cards.length))info.dataset.pieceTotal=n(cards.length);
      });
      const text=(first===last?n(first):n(first)+'–'+n(last))+' / '+n(cards.length);
      if(progress.textContent!==text)progress.textContent=text;
      progress.setAttribute('aria-label',`Pieces ${first}${first===last?'':' to '+last} of ${cards.length}`);
    };
    let frame=0;
    const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);};
    grid.addEventListener('scroll',schedule,{passive:true});
    new ResizeObserver(schedule).observe(grid);
    new MutationObserver(schedule).observe(dialog,{attributes:true,attributeFilter:['open']});
    schedule();
  };
  const scan=()=>document.querySelectorAll('dialog.srlm-featured-focus').forEach(enhance);
  scan();
  new MutationObserver(scan).observe(document.body,{childList:true,subtree:true});
})();
